export const EditIcon = () => {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.74616 16.0886L12.9755 12.2635C12.9858 12.2543 12.9956 12.2444 13.0048 12.2341C13.1525 12.0698 13.1389 11.8169 12.9745 11.6693L8.79479 7.9156C8.42454 7.58309 8.39324 7.0126 8.72487 6.64138C9.05651 6.27016 9.6255 6.23878 9.99574 6.57128L15.2515 11.2913C15.6499 11.6491 15.651 12.2743 15.2538 12.6335L9.9518 17.4287C9.58272 17.7625 9.01362 17.7332 8.6807 17.3631C8.34777 16.993 8.37708 16.4224 8.74616 16.0886Z" fill="#6F6F70" />
    </svg>
  );
};
